/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

console.log('Environment:', process.env.NODE_ENV);

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: "3bc9c292-e26a-4fe2-8fdd-8b7db0dc967e",
    authority: "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize",
    redirectUri: process.env.NODE_ENV === "production" ? process.env.REACT_APP_REDIRECT_URL_PRODUCTION
                                                       : process.env.REACT_APP_REDIRECT_URL_DEVELOPMENT,
    postLogoutRedirectUri: process.env.NODE_ENV === "production" ? process.env.REACT_APP_REDIRECT_URL_PRODUCTION
                                                                 : process.env.REACT_APP_REDIRECT_URL_DEVELOPMENT,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message); // turn on for debugging
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [],
  prompt: "select_account"  // Force the account selection
};
